import { Route } from "@angular/router";
import { CentralDeAjudaPage } from "./central-de-ajuda.page";

export const CentralDeAjudaRouter: Route[] = [
  { path: 'planos', component: CentralDeAjudaPage }
];
